import {
    NavLink
} from "reactstrap";
import {
    // NavLink as RRNavLink, 
    useHistory, useRouteMatch
} from "react-router-dom";
import React, {
    // useContext,
    useEffect, useRef, useState
} from "react";
// import { SchoolContext } from "../context/SchoolContext";
import { DashBoard, Device, Graph, Errors, PowerMgmt, Setting, Network, Logout, Home, RemoteControl, TechSupport, Notice } from "./Logo";

const LeftNavigationMobile = ({ setControlType }) => {
    // const { school } = useContext(SchoolContext);
    const [isActive, setIsActive] = useState(0);
    // const checkSchool = localStorage.getItem("curr_school")
    const history = useHistory()

    let { url } = useRouteMatch();
    const onChangeActive = (v, path) => {
        history.push(path)
        setIsActive(v)
    }

    const pathname = history["location"].pathname
    const schoolId = Number(pathname.split('/').pop());
    const admin = localStorage.getItem('username');
    const [isSubmenuActive, setIsSubmenuActive] = useState(false);
    const [isSettingActive, setIsSettingActive] = useState(false);
    const tooltipRef = useRef(null);
    const toggleSubmenu = () => {
        setIsSubmenuActive(!isSubmenuActive);
    };
    useEffect(() => {
        // if (checkSchool === null) {
        //     setIsActive(0);
        // }
        if (!Number.isNaN(schoolId) || pathname.startsWith('/home/dashboard')) {
            setIsActive(0);
        }
    }, [pathname, schoolId])

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
                setIsSettingActive(false);
            }
        };

        // Add the event listener to the document
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    return (
        <div id="leftnavMobile">
            <div className="d-flex flex-column h-100">
                <div className="newBorder ">
                    <div className="pointer navitem-padding" onClick={() => {
                        setIsSubmenuActive(false); setIsSettingActive(false);
                        schoolId && !Number.isNaN(schoolId) && pathname !== "/home/setting" ? onChangeActive(0, `${url}/dashboard/${schoolId}`) : onChangeActive(0, "/home")
                    }
                    } style={
                        { backgroundColor: `${isActive === 0 && (pathname.startsWith("/home/dashboard") || pathname === ("/home")) ? "#223c6a" : ""}`, color: `${isActive === 0 && (pathname.startsWith("/home/dashboard") || pathname === ("/home")) ? "#fff" : ""}` }
                        // pathname.startsWith("/home") || pathname.startsWith("/home/dashboard") ? { backgroundColor: "#223c6a", color: "#fff" } : {}
                    }>
                        {!Number.isNaN(schoolId) && pathname !== "/home" && pathname !== "/home/setting" ? <>
                            <DashBoard fill={`${isActive === 0 && pathname.startsWith("/home/dashboard") ? "#fff" : "#223c6a"}`} className="imgIcons" /><br />
                            {/* <span className="text__small">ダッシュボード</span>  */}
                        </> :
                            <>
                                <Home fill={`${isActive === 0 && pathname === "/home" ? "#fff" : "#223c6a"}`} className="imgIcons" /><br />
                                {/* <span className="text__small">ホーム</span> */}
                            </>
                        }
                    </div>



                </div>
                {schoolId && !Number.isNaN(schoolId) && (pathname !== "/home" && pathname !== "/home/setting") ?
                    <>
                        <div className="newBorder">
                            <div className="pointer" onClick={() => { onChangeActive(1, `${url}/graph/${schoolId}`); setIsSubmenuActive(false); setIsSettingActive(false); }} style={
                                pathname.startsWith("/home/graph") ? { backgroundColor: "#223c6a", color: "#fff" } : {}
                            }>
                                <Graph fill={`${pathname.startsWith("/home/graph") ? "#fff" : "#233C6B"}`} className="imgIcons" /><br />
                                {/* <span className="text__small">電力履歴</span> */}
                            </div>


                        </div>
                        <div className="newBorder">

                            <div className="pointer" onClick={() => { onChangeActive(2, `${url}/device/${schoolId}`); setIsSubmenuActive(false); setIsSettingActive(false); }} style={
                                pathname.startsWith("/home/device") ? { backgroundColor: "#223c6a", color: "#fff" } : {}
                                // { backgroundColor: `${isActive === 6 ? "#223c6a" : ""}`, color: `${isActive === 6 ? "#fff" : ""}` }
                            }>
                                <Device fill={`${pathname.startsWith("/home/device") ? "#fff" : "#233C6B"}`} className="imgIcons" /><br />
                                {/* <img src="img/setting.svg" alt="logo" className="imgIcons" /><br /> */}
                                {/* <span className="text__small">デバイス情報</span> */}
                            </div>


                        </div>
                        <div className="newBorder">
                            <div className="pointer" onClick={() => { onChangeActive(3, `${url}/error/${schoolId}`); setIsSubmenuActive(false); setIsSettingActive(false); }} style={
                                pathname.startsWith("/home/error") ? { backgroundColor: "#223c6a", color: "#fff" } : {}
                                // { backgroundColor: `${isActive === 6 ? "#223c6a" : ""}`, color: `${isActive === 6 ? "#fff" : ""}` }
                            }>
                                <Errors fill={`${pathname.startsWith("/home/error") ? "#fff" : "#233C6B"}`} className="imgIcons" /><br />
                                {/* <img src="img/setting.svg" alt="logo" className="imgIcons" /><br /> */}
                                {/* <span className="text__small">イベント履歴</span> */}
                            </div>


                        </div>
                        <div className="newBorder">

                            <div className="pointer" onClick={() => { onChangeActive(4, `${url}/individual/${schoolId}`); setIsSubmenuActive(false); setIsSettingActive(false); }} style={
                                pathname.startsWith("/home/individual") ? { backgroundColor: "#223c6a", color: "#fff" } : {}
                                // { backgroundColor: `${isActive === 6 ? "#223c6a" : ""}`, color: `${isActive === 6 ? "#fff" : ""}` }
                            }>
                                <PowerMgmt fill={`${pathname.startsWith("/home/individual") ? "#fff" : "#233C6B"}`} className="imgIcons" /><br />
                                {/* <img src="img/setting.svg" alt="logo" className="imgIcons" /><br /> */}
                                {/* <span className="text__small">電力管理</span> */}
                            </div>

                        </div>
                        {admin !== null && admin === "SEMSPJ001" ? <div className="newBorder">

                            <div className="pointer" onClick={() => { onChangeActive(5, `${url}/communication/${schoolId}`); setIsSubmenuActive(false); setIsSettingActive(false); }} style={
                                pathname.startsWith("/home/communication") ? { backgroundColor: "#223c6a", color: "#fff" } : {}
                                // { backgroundColor: `${isActive === 6 ? "#223c6a" : ""}`, color: `${isActive === 6 ? "#fff" : ""}` }
                            }>
                                <Network fill={`${pathname.startsWith("/home/communication") ? "#fff" : "#233C6B"}`} className="imgIcons" /><br />
                                {/* <img src="img/setting.svg" alt="logo" className="imgIcons" /><br /> */}
                                {/* <span className="text__small">通信管理</span> */}
                            </div>

                        </div> : ""}
                        <div className="newBorder">
                            <div className="pointer" onClick={() =>
                                onChangeActive(8, `${url}/remoteControl/${schoolId}`)
                                // toggleSubmenu()
                            } style={
                                pathname.startsWith("/home/remoteControl") ? { backgroundColor: "#223c6a", color: "#fff" } : {}
                            }>
                                <RemoteControl fill={`${pathname.startsWith("/home/remoteControl") ? "#fff" : "#233C6B"}`} className="imgIcons" /><br />
                            </div>
                            {/* {isSubmenuActive && (
                                <div className="subMenu">
                                    <ul>
                                        <li onClick={(e) => {
                                            e.stopPropagation();
                                            onChangeActive(8, `${url}/remoteControl/${schoolId}`);
                                            toggleSubmenu();
                                            setControlType('one')
                                        }}
                                        >one time</li>
                                        <li onClick={(e) => {
                                            e.stopPropagation();
                                            onChangeActive(8, `${url}/remoteControl/${schoolId}`);
                                            toggleSubmenu();
                                            setControlType('schedule')
                                        }}
                                        >scheduled</li>
                                    </ul>
                                </div>
                            )} */}
                        </div>
                    </> : ''
                }
                {admin !== null && admin === "SEMSPJ001" && (pathname === "/home" || pathname === "/home/user" || pathname === "/home/notice") ? <div className="newBorder" >
                    <div className="pointer" onClick={() => { setIsSettingActive(true); }}
                        style={
                            pathname.startsWith("/home/user") || pathname.startsWith("/home/notice") ? { backgroundColor: "#223c6a", color: "#fff" } : {}
                        }>
                        <Setting fill={`${pathname.startsWith("/home/user") || pathname.startsWith("/home/notice") ? "#fff" : "#233C6B"}`} className="imgIcons" /><br />
                        {/* <span className="text__small">設定</span> */}
                    </div>
                    {isSettingActive && (
                        <div className="setting_submenu" ref={tooltipRef}>
                            <ul>
                                <li onClick={(e) => {
                                    e.stopPropagation();
                                    onChangeActive(6, `${url}/user`);
                                    setIsSettingActive(false);
                                }}
                                ><TechSupport />
                                </li>
                                <li onClick={(e) => {
                                    e.stopPropagation();
                                    onChangeActive(8, `${url}/notice`);
                                    setIsSettingActive(false);
                                }}
                                ><Notice /></li>
                            </ul>
                        </div>
                    )}
                </div> : ""}
                <div className="newBorder last">
                    <NavLink to="/logout" activeclassname="active" onClick={() => {
                        onChangeActive(7, "/logout")
                    }}
                    >
                        <Logout fill={`${isActive === 7 ? "#fff" : "#233C6B"}`} className="imgIcons" /><br />
                        {/* <img src="img/logout.svg" alt="logo" className="imgIcons" /><br /> */}
                        {/* <span className="text__small">ログアウト</span> */}
                    </NavLink>
                </div>
            </div>
        </div >
    )

}

export default LeftNavigationMobile;